/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SingleVantPicker',
  props: {
    value: {
      type: [String, Number]
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    fieldValue: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    },
    fieldName: function fieldName() {
      var _this = this;
      var tmp = this.columns.find(function (v) {
        return v.value === _this.fieldValue;
      });
      return tmp ? tmp.label : '';
    }
  },
  data: function data() {
    return {
      showPicker: false
    };
  },
  created: function created() {}
};